const SOURCE = {
    'SITE': 'A_0',
    'HANDS': 'A_1'
};

const STATUSES = {
    'UNPAID': "A_0",
    'ACCEPTED': "A_1",
    'MOVED': "A_2",
    'RETURNED': "A_3",
    'REJECTED': "A_4",
    'CANCELED': "A_5"
};

class BaseOrder {
    constructor(data) {
        this.data = data;
    }

    updateFromJson(json) {
        this.data = {...this.data, ...json};
    }

    get events() {
        //todo: should be implemented in subclass
        //return [{...this.data.event, orderId: this.id}];
    }

    get isTicket() {
        //todo: should be implemented in subclass
    }

    get isOrderPaid() {
        const status = this.data?.payment?.status;
        const source = this.data?.source;
        if (!this.data.payment) return false;
        if (source === SOURCE['HANDS'] && status !== STATUSES['ACCEPTED'])
            return false;
        if (source === SOURCE['SITE'] && status === STATUSES['UNPAID']) {
            return false;
        }
        return true;
    }

    isEventPassed(event = this.order.event) {
        if (this.isOrderPaid) {
            return new Date(event?.endDate) < new Date();
        } else {
            return new Date(event?.endDate).setHours(23, 59) < new Date();
        }
    }

    isTransferAndCancelDisabled(event = this.order.event) {
        if (Math.sign(new Date(event?.startDate) - new Date()) === -1) return true
        return this.data?.service?.meetingType === 'OFF' ?
            new Date(event?.startDate) - new Date() < 86400000 :
            new Date(event?.startDate) - new Date() < 43200000
    }

    get isEventAWeekOld() {
        const date = new Date(this.order?.event?.startDate)
        return new Date(new Date(date).setDate(date.getDate() + 7)).setHours(23, 59) < new Date();
    }

    get isOrderPaymentExpired() {
        return new Date(this.data?.payUntil) < new Date() && this.data?.payment?.status !== 'A_1';
    }

    get order() {
        //todo: should be implemented in subclass
    }

    get isOrderHistory() {
        if (this.isOrderPaid && this.isEventPassed()) return true;
        //if (!this.isOrderPaid && this.isOrderPaymentExpired) return true;
        if (!this.isOrderPaid && this.isEventAWeekOld && !this.isOrderPaymentExpired) return true;
        return false
    }

    get isOrderActive()  {
        if (this.isOrderPaid && !this.isEventPassed()) return true;
        if (!this.isOrderPaid && !this.isOrderPaymentExpired && !this.isEventAWeekOld) return true;
        return false
    }

    get payUntil() {
        if (!this.isOrderPaid && this.isOrderActive && new Date(this.order.payUntil).getFullYear() < 2088) {
            return this.order.payUntil;
        }
        return null;
    }

}

export default BaseOrder;
